import { Dispatch, ThunkAction } from '../../../../../../types/actions';
import { IGetState, TCardId } from '../../../../../../types/types';
import { ICards } from '../../../../../../store/model/cards/types';
import { IRestCard } from '../../../../../../types/rest/IRestCard';
import { subcardsGetRest } from '../subcardsGetRest';
import { cardsUpdate } from 'app/store/model/actionCreators/cardsUpdate';

export const cardSubcardsGetRest = (
    epicId: TCardId
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        if (!epicId) Promise.reject();

        dispatch(subcardsGetRest(epicId))
            .then((cardsFromResponses: Array<IRestCard>) => {
                const cards = cardsFromResponses.reduce((map: ICards, card) =>{
                    map[card.id] = card;
                    return map;
                }, {});
                dispatch(cardsUpdate(cards));
                return cards;
            });
    };
    return action;
};
